import { useMemo } from "react";
import { buildSessionId, getDeviceFingerprintId } from "../lib/deviceFingerprint";

export interface DeviceFingerprint {
  /** Identificador de la operación. Es lo que se manda al backend. */
  deviceFingerprintId?: string;
  /** merchantID + identificador. Es lo que va en las URLs de online-metrix. */
  sessionId?: string;
}

/**
 * Resuelve el device fingerprint de un checkout. Fuera de GT devuelve `{}` y eso
 * apaga las dos mitades: sin `sessionId` no se monta el script, sin
 * `deviceFingerprintId` el campo no viaja en el POST ni en Mixpanel.
 *
 * `country` conviene leerlo de `useParams()` y no de Redux: `store.country` se
 * setea en un useEffect de AppRouter y en el primer render vale ''.
 */
export const useDeviceFingerprint = (
  scope: string,
  country?: string | null
): DeviceFingerprint =>
  useMemo(() => {
    const deviceFingerprintId = getDeviceFingerprintId(scope, country);
    if (!deviceFingerprintId) return {};
    return { deviceFingerprintId, sessionId: buildSessionId(deviceFingerprintId) };
  }, [scope, country]);

export default useDeviceFingerprint;
